
import style from './NavLinks.module.css'
import { Link } from 'react-router-dom'
import { ReactComponent as Home } from '../../Assets/icons/Home.svg';
import { ReactComponent as Table } from '../../Assets/icons/Table.svg';
import { ReactComponent as Settings } from '../../Assets/icons/Settings.svg';
import { ReactComponent as Help } from '../../Assets/icons/help.svg';

export default function NavLinks({location}) {
    
    return <div className={style.nav}>
        <div className={style.links}>
            <Link to='/' className={`${style.navLink} ${location === '/' && style.active}`}> 
                <Home stroke={location === '/' ? '#d321cc' : '#7E84A3'} /> <span>Рабочий стол</span> </Link>
            <Link to='table' className={`${style.navLink} ${location === '/table' && style.active}`}> 
                <Table stroke={location === '/table' ? '#d321cc' : '#7E84A3'} /> <span>Таблица</span></Link>
        </div>

        <div className={style.links}>
        <Link to={process.env.REACT_APP_ADMIN_URL} className={`${style.navLink} ${location === '/help' && style.active}`}>
        <Settings stroke={location === '/settings' ? '#d61017' : '#7E84A3'} /> <span>Настройки</span></Link>
        </div>
    </div>
}

